import { useEffect } from 'react';
import { Box, CircularProgress, Alert } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import FormSRT from '../../../Siniestros/components/FormSRT';
import {
    useGetFormularioSrtVisitaQuery,
    usePatchFormularioSrtVisitaMutation,
    useGetDatosParametricosSrtVisitaQuery
} from '../../../../services/visitasApi';

interface FormSRTVisitaProps {
    idVisita: number;
    readOnly?: boolean;
    siniestro?: any;
    onSaveSuccess?: () => void;
    lockAutocompletedFields?: boolean;
}

const FormSRTVisita = ({
    idVisita,
    readOnly = false,
    siniestro,
    onSaveSuccess,
    lockAutocompletedFields
}: FormSRTVisitaProps) => {
    const {
        data: formularioData,
        isLoading: isLoadingFormulario,
        error: formularioError
    } = useGetFormularioSrtVisitaQuery({ idVisita });

    const { data: parametricData, isLoading: isLoadingParametrics } =
        useGetDatosParametricosSrtVisitaQuery({ idVisita });

    const [patchFormulario, { isLoading: isSaving }] = usePatchFormularioSrtVisitaMutation();

    const formularioErrorStatus = (formularioError as any)?.status;
    const isFatalError = Boolean(formularioError) && formularioErrorStatus !== 404;

    useEffect(() => {
        if (!isFatalError) return;
        const msg =
            (formularioError as any)?.data?.message || 'No se pudo cargar el formulario SRT.';
        enqueueSnackbar(msg, { variant: 'error' });
    }, [isFatalError, formularioError]);

    const handleSave = async (body: any) => {
        await patchFormulario({ idVisita, body }).unwrap();
        onSaveSuccess?.();
    };

    if (isLoadingFormulario || isLoadingParametrics) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
                <CircularProgress size={32} />
            </Box>
        );
    }

    if (isFatalError) {
        const errorMsg =
            (formularioError as any)?.data?.message || 'No se pudo cargar el formulario SRT.';
        return (
            <Alert severity="error" sx={{ my: 2 }}>
                {errorMsg}
            </Alert>
        );
    }

    const formularioDataOrNull = formularioErrorStatus === 404 ? null : formularioData;

    return (
        <FormSRT
            siniestro={siniestro}
            overrides={{
                skipInternalQueries: true,
                formularioDataOverride: formularioDataOrNull,
                parametricDataOverride: parametricData,
                onSaveOverride: handleSave,
                isSaving,
                readOnly,
                hideExport: true,
                lockAutocompletedFields
            }}
        />
    );
};

export default FormSRTVisita;
